<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-06-29 16:27:26
 * @LastEditTime: 2021-09-24 16:56:06
 * @LastEditors: chenguobiao
-->
<template>
  <div
    class="logo flex items-center cursor-pointer"
    @click="backHome"
  >
    <img class="img" src="@/render/assets/images/header/logo.png" />
  </div>
</template>

<script>
export default {
  name: 'HomeLogo',
  props: {},
  data() {
    return {}
  },
  components: {},
  computed: {},
  async mounted() {},
  methods: {
    backHome() {
      this.$emit('handleBackHome')
    }
  },
}
</script>

<style lang="scss" scoped>
.logo {
  .img {
    width: val(411);
    height: val(54);
  }
}
</style>
